import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { config } from "../../utils/config";
import { FaCircleCheck } from "react-icons/fa6";
import { toast } from "react-toastify";
import {
    UserOutlined
} from '@ant-design/icons';
export default function BasicDetailsStep({ AadharVerified, setIsAadharVerified, data, setData, getAllbusinessInfo, isPANVerified, setIsPANVerified, verifyPanDetails, setIsGSTVerified, isGSTVerified, setPrefillBasicData, prefillBasicData }) {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const seller_id = query.get("seller_id");
    const client_token = query.get("client_token");
    const state = query.get("state");
    const { apiEndpoint } = config;
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({
            ...data,
            [name]: value
        });
    };

    // useEffect(() => {
    //     if (prefillBasicData && !data?.pan_number) {
    //         setData({
    //             ...data,
    //             pan_number: prefillBasicData?.pan_no || "",
    //             pan_name: prefillBasicData?.pan_name || ""
    //         });
    //     }
    // }, [prefillBasicData]);


    console.log("prefillBasicDataprefillBasicData", prefillBasicData?.pan_name);
    const verifyPanHandler = async () => {
        try {
             if (window.gtag) {
            window.gtag("event", "aadhaar_kyc_verify_button_clicked", {
                event_category: "KYC",
                event_label: "Aadhaar KYC Verification Started",
            });
        }
            setIsLoading(true);
            const res = await verifyPanDetails(
                // data.pan_name,
                data.pan_number
            );
            if (!res?.digi_locker_url) {
                toast.error(res.error);
                setIsLoading(false);
                return
            }

            console.log("res--->", res)

            if (res?.digi_locker_url) {
                window.location.replace(res.digi_locker_url);
                // setIsPANVerified(true);
            }
        } catch (err) {
            console.log("PAN Error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const isValidPAN = (pan_number) => {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

        if (pan_number) {
            return true
        } else {
            return false
        }
    };

    const sendEntireData = async () => {
        if (!seller_id || !client_token || !state) return;
        try {
            const res = await axios.post(
                `${apiEndpoint}/send-entire-data`,
                {
                    seller_id: Number(seller_id),
                    client_token,
                    state,
                }
            );
            setData((prev) => {
                return {
                    ...prev,
                    // pan_name: res.data?.response?.data?.name_on_pan,
                    pan_number: res.data?.response?.data?.aadhar_no
                }
            })
            setIsAadharVerified(true)
            // setIsPANVerified(true);
            // setIsGSTVerified(true);
            // setShowPanfield(true);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        sendEntireData();
    }, []);

    return (
        <>
            <h2 className="h4 mt-5 fw-semibold text-dark mb-0 px-0 pt-0 pb-4" style={{ color: "black", fontSize: "20px", fontWeight: "600" }}>
                KYC Verification and Basic Details

            </h2>
            <div className="shadow-sm p-4 pt-0 rounded rounded-5 border bg-white mt-1">

                <h2 className="h4  fw-semibold text-dark mb-0 px-0 pt-0 pb-4 d-flex align-items-center" style={{ color: "black", fontSize: "20px", fontWeight: "600", gap: "5px" }}>
                    <UserOutlined />     Aadhar Details

                </h2>
                {AadharVerified && data?.pan_number !== "" ? (
                    <div className="alert mb-3 alert-success mb-0 p-2 d-flex align-items-center" style={{ gap: "5px", color: "green", background: "#e8f3e8", borderColor: "#2B912B" }}>
                        <FaCircleCheck /> Your aadhar details have been verified successfully.
                    </div>
                ) : null}
                <div>
                    <div className="d-flex position-relative" style={{ gap: "16px" }}>
                        <div className="mb-3 w-100">
                            <label style={{ color: "grey !important" }} >
                                Aadhar Number <span>*</span>
                            </label>

                            <input
                                type="text"
                                name="pan_number"
                                value={data.pan_number}
                                onChange={handleChange}
                                className="form-control w-100 text-secondary"
                                placeholder="XXXX XXXX XXXX"
                                style={{ background: "#F3F3F5" }}
                                readOnly={AadharVerified ? true : false}
                            />
                        </div>
                        {!AadharVerified && !data?.pan_number !== "" ? (
                            <button
                                className="btn btn-sm p-2 d-flex justify-content-center "
                                onClick={verifyPanHandler}
                                disabled={!isValidPAN(data?.pan_number, data?.pan_name)}
                                style={{
                                    position: "absolute",
                                    top: "34.5px",
                                    right: "3px",
                                    background: "linear-gradient(90deg, #F75710, #FC8809)",
                                    color: "#fff",
                                    border: "none",
                                    outline: "none",
                                    borderRadius: "8px",
                                    opacity: (isLoading || !isValidPAN(data?.pan_number)) ? 0.6 : 1,
                                    width: "80px"
                                }}
                            >
                                {isLoading ? "Processing..." : "Verify"}
                            </button>
                        ) : null}

                    </div>

                </div>
            </div>
        </>
    );
}
